import { render, staticRenderFns } from "./itemGrupo.vue?vue&type=template&id=a3b48526&scoped=true&"
import script from "./itemGrupo.vue?vue&type=script&lang=js&"
export * from "./itemGrupo.vue?vue&type=script&lang=js&"
import style0 from "./itemGrupo.vue?vue&type=style&index=0&id=a3b48526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b48526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
